import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ktt_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use((r) => r, (err) => {
  if (err?.response?.status === 402) window.dispatchEvent(new Event("ktt-locked"));
  return Promise.reject(err);
});

export function apiError(e, fallback = "Bir hata oluştu") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export default api;

export async function downloadFile(path, filename) {
  try {
    const r = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(new Blob([r.data], { type: r.headers["content-type"] || "application/pdf" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  } catch (e) {
    // Hata gövdesi blob olarak gelir; gerçek {detail} mesajını çıkar ki apiError okuyabilsin
    const data = e?.response?.data;
    if (data instanceof Blob) {
      try {
        const txt = await data.text();
        e.response.data = JSON.parse(txt);
      } catch { /* JSON değilse dokunma */ }
    }
    throw e;
  }
}
